import type { insuranceMonitorSettingsApiSpec } from "@wingspanhq/wingspan-api-types";
import * as Yup from "yup";

import { RequirementDefinitionStandardIdentityVerificationFormValues } from "../../../../types";
import { RequirementDefinitionTemplateForm } from "../../types";

export const STANDARD_IDENTITY_VERIFICATION_FORM: RequirementDefinitionTemplateForm<
  insuranceMonitorSettingsApiSpec.InsuranceCoverageMonitorSettings,
  RequirementDefinitionStandardIdentityVerificationFormValues,
  null
> = {
  getDefaultSettingsValues: template => ({}),
  getEditSettingsValues(template, requirementDefinition) {
    return {};
  },
  mapDataSourceResponseToRequirementCreateRequest: null,
  mapFormDataToDataSourceCreateRequest: null,
  partialForm: null,
  successCreationMessage: "Requirement created successfully",
  validationSchema: Yup.object().shape({})
};
